export default __webpack_public_path__ + "static/media/notFoundTiledBackround.fb2187a4.png";